export default __webpack_public_path__ + "static/media/II-2019.a6a8c391.pdf";